import { motion } from 'motion/react';
import { ArrowRight, Truck, Monitor, Factory, Store } from 'lucide-react';
import { ScrollReveal } from '@/components/motion/scroll-reveal';
import { industries } from '../data/landing-data';
import { useBookDemoStore } from '../store/book-demo-store';

const industryIcons = {
  distribuidoras: Truck,
  tecnologia: Monitor,
  manufactura: Factory,
  mayoristas: Store,
} as const;

export function IndustryStripSection() {
  const openDemo = useBookDemoStore((s) => s.open);
  return (
    <section className="py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal className="text-center mb-10">
          <p className="text-sm font-semibold text-violet-600 dark:text-violet-400 tracking-wider uppercase mb-2">
            Soluciones
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white">
            Diseñado para{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-600 to-blue-600">
              tu industria
            </span>
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {industries.map((industry, i) => {
            const Icon = industryIcons[industry.slug as keyof typeof industryIcons];
            return (
              <motion.div
                key={industry.slug}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-40px' }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
              >
                <button
                  type="button"
                  onClick={() => openDemo({ industry: industry.shortName })}
                  className="group block w-full text-left rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900/50 p-5 hover:border-blue-200 dark:hover:border-blue-500/30 hover:shadow-lg dark:hover:shadow-blue-500/5 transition-all cursor-pointer"
                >
                  <div
                    className={`w-10 h-10 rounded-lg bg-gradient-to-br ${industry.gradient} flex items-center justify-center mb-3`}
                  >
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-1">
                    {industry.name}
                  </h3>
                  <p className="text-xs text-gray-500 dark:text-gray-400 leading-relaxed mb-3">
                    {industry.tagline}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-blue-600 dark:text-blue-400 group-hover:text-blue-700 dark:group-hover:text-blue-300 transition-colors">
                    Ver Prixia en mi industria
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-0.5 transition-transform" />
                  </span>
                </button>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
